<template>
  <div class="point-page">
    <div v-if="type === 'edit'" class="reject_box">
      <div class="sub_title">
        <svg-icon icon-class="warning" />&nbsp;&nbsp;Approval Instructions
      </div>
      <div class="refusalReason">{{ pageData.refusalReason }}</div>
    </div>
    <div>
      <div class="sub_title img">
        Basic Information
        <img
          v-if="['OIL', 'ALL'].includes(pageData.type)"
          src="@/assets/image/well/oil.png"
          alt=""
          srcset=""
          style="width: 0.66rem; height: 0.24rem; margin-left: 0.15rem"
        >
        <img
          v-if="['GAS', 'ALL'].includes(pageData.type)"
          src="@/assets/image/well/gas.png"
          alt=""
          srcset=""
          style="width: 0.66rem; height: 0.24rem; margin-left: 0.15rem"
        >
      </div>
      <el-form
        ref="addWellForm"
        class="page-form point-form"
        :model="pageData"
        :rules="pageRules"
        label-position="top"
      >
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item prop="nickname" label="Well Name">
              <el-input
                v-model="pageData.nickname"
                type="text"
                auto-complete="off"
                placeholder="Please fill in"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="type === 'edit'" :span="12">
            <el-form-item label="Unique ID">
              <account :value="getId(pageData)" />
            </el-form-item>
          </el-col>
          <el-col :span="24" />
          <el-col :span="12">
            <el-form-item prop="UWI" label="AER UWI">
              <el-input
                v-model="pageData.UWI"
                type="text"
                auto-complete="off"
                placeholder="Please fill in"
                :disabled="type !== 'edit'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fromToIDIdentifier" label="FromToIDIdentifier">
              <el-input
                v-model="pageData.fromToIDIdentifier"
                type="text"
                auto-complete="off"
                placeholder="Please fill in"
                :disabled="type !== 'edit'"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="showFlag" :span="12">
            <el-form-item prop="sulphur" label="Sulphur Content">
              <el-input
                v-model="pageData.sulphur"
                type="text"
                auto-complete="off"
                placeholder="Please fill in"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="showFlag" :span="12">
            <el-form-item prop="APIGravity" label="API Gravity">
              <el-input
                v-model="pageData.APIGravity"
                type="text"
                auto-complete="off"
                placeholder="Please fill in"
              />
            </el-form-item>
          </el-col>

          <el-col v-if="showFlag" :span="12">
            <el-form-item prop="oilAnalysis" label="Oil Analysis">
              <file-upload
                :default-file-list="
                  pageData.oilAnalysis
                    ? [{ name: pageData.oilAnalysis, uid: pageData.oilAnalysis }]
                    : undefined
                "
                @onSuccess="handleFileSuccess($event, 'oilAnalysis')"
                @onRemove="handleFileRemove($event, 'oilAnalysis')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="wellLisence" label="Well Lisence">
              <file-upload
                :default-file-list="
                  pageData.wellLisence
                    ? [{ name: pageData.wellLisence, uid: pageData.wellLisence }]
                    : undefined
                "
                @onSuccess="handleFileSuccess($event, 'wellLisence')"
                @onRemove="handleFileRemove($event, 'wellLisence')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <Share v-if="type !== 'edit'" ref="ShareCom" />
    </div>
  </div>
</template>

<script>
/* global web3 */
import { checkWell } from '@/api/producer.js'
import { addWell, updateWell, wellList } from '@/api/well.js'
import Share from './share.vue'

export default {
  components: {
    Share
  },
  props: {
    type: {
      type: String,
      default: () => {
        return 'add'
      }
    },
    wellIndex: {
      type: Number,
      default: () => {
        return 0
      }
    },
    removeDisabled: {
      type: Boolean
    },
    defaultPageData: {
      type: Object,
      default: () => {
        return {
          nickname: undefined,
          fromToIDIdentifier: undefined,
          UWI: undefined,
          sulphur: undefined,
          APIGravity: undefined,
          oilAnalysis: undefined,
          wellLisence: undefined,
          type: undefined
        }
      }
    }
  },
  data() {
    return {
      pageData: {},
      pageRules: {
        nickname: [
          {
            required: true,
            trigger: 'blur',
            message: 'Well Name cannot be empty'
          }
        ],
        fromToIDIdentifier: [
          {
            required: true,
            trigger: 'blur',
            message: 'FromToIDIdentifier cannot be empty'
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        UWI: [
          {
            required: true,
            trigger: 'blur',
            message: 'AER UWI cannot be empty'
          },
          { min: 1, max: 20, message: 'Within 20 characters', trigger: 'blur' }
        ],
        sulphur: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('Sulphur Content cannot be empty'))
              } else if (value > 100) {
                return callback(new Error(this.dict.reg.sulphur.desc))
              } else if (!this.dict.reg.sulphur.value.test(value)) {
                return callback(new Error(this.dict.reg.sulphur.desc))
              } else {
                callback()
              }
            }
          }
        ],
        APIGravity: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('API Gravity Content cannot be empty'))
              } else if (value > 100) {
                return callback(new Error(this.dict.reg.APIGravity.desc))
              } else if (!this.dict.reg.APIGravity.value.test(value)) {
                return callback(new Error(this.dict.reg.APIGravity.desc))
              } else {
                callback()
              }
            }
          }
        ],
        oilAnalysis: [
          {
            required: true,
            message: 'OIL ANALYSIS Content cannot be empty'
          }
        ],
        wellLisence: [
          {
            required: true,
            message: 'WELL LISENCE Content cannot be empty'
          }
        ]
      },
      locationOptions: [],
      oilContract: undefined,
      oilAddress: undefined,
      gasContract: undefined,
      gasAddress: undefined
    }
  },
  computed: {
    showFlag() {
      return this.type !== 'edit' || this.pageData.type === 'OIL'
    }
  },
  created() {
    if (this.type === 'edit') {
      wellList({
        wellID: this.$route.query.wellID
      }).then((res) => {
        this.pageData = res.result || {}
      })
    } else {
      this.pageData = this.defaultPageData
      this.pageData.UWI = this.$route.query.UWI
      this.pageData.fromToIDIdentifier = this.$route.query.fromToIDIdentifier
      this.pageData.type = this.$route.query.type
    }
    this.getAbi('OilProducer').then((res) => {
      this.oilContract = new web3.eth.Contract(res.data.abi, res.data.address)
      this.oilAddress = res.data.address
    })
    this.getAbi('GasProducer').then((res) => {
      this.gasContract = new web3.eth.Contract(res.data.abi, res.data.address)
      this.gasAddress = res.data.address
    })
  },
  methods: {
    handleFileSuccess({ response, file, fileList }, item) {
      this.pageData[item] = response.result.fileName
      this.$refs.addWellForm.validateField(item)
    },
    handleFileRemove(fileList, item) {
      this.pageData[item] = undefined
      this.$refs.addWellForm.validateField(item)
    },
    deleteWell() {
      this.$emit('remove', this.wellIndex, this.pageData.wellID)
    },
    checkWellFun(well) {
      return new Promise((resolve, reject) => {
        checkWell(well)
          .then((res) => {
            if (res.result) {
              resolve()
            } else {
              this.$message.warning('Well info already exists! ')
              reject('Well info already exists! ')
            }
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    check() {
      return new Promise((resolve, reject) => {
        let wellFlag = false
        let reqArr = []
        this.$refs.addWellForm.validate((valid) => {
          wellFlag = valid
        })
        this.pageData.sulphur = Number(this.pageData.sulphur)
        this.pageData.APIGravity = Number(this.pageData.APIGravity)
        if (!wellFlag) {
          this.$message.error('Please complete the required items')
          reject('Please complete the required items')
          return
        }
        if (this.pageData.type === 'ALL') {
          reqArr = [
            this.checkWellFun({ ...this.pageData, type: 'OIL' }),
            this.checkWellFun({ ...this.pageData, type: 'GAS' }),
            this.$refs.ShareCom.shareCheck()
          ]
        } else {
          reqArr = [this.checkWellFun(this.pageData), this.$refs.ShareCom.shareCheck()]
        }

        Promise.all(reqArr)
          .then((res) => {
            resolve(res)
            return
          })
          .catch((e) => {
            reject(e)
            return
          })
      })
    },
    editSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs.addWellForm.validate((valid) => {
          if (valid) {
            if (this.pageData.wellID) {
              const json = {
                wellID: this.pageData.wellID,
                nickname: this.pageData.nickname,
                fromToIDIdentifier: this.pageData.fromToIDIdentifier,
                UWI: this.pageData.UWI,
                sulphur: Number(this.pageData.sulphur),
                APIGravity: Number(this.pageData.APIGravity),
                oilAnalysis: this.pageData.oilAnalysis,
                wellLisence: this.pageData.wellLisence,
                type: this.pageData.type
              }
              this.checkWellFun(json)
                .then(() => {
                  updateWell(json)
                    .then((res) => {
                      resolve(res)
                    })
                    .catch((err) => {
                      reject(err)
                    })
                })
                .catch((err) => {
                  reject(err)
                })
            }
          } else {
            reject()
          }
        })
      })
    },
    addSubmit(type) {
      return new Promise((resolve, reject) => {
        this.$refs.addWellForm.validate((valid) => {
          if (valid) {
            addWell({ ...this.pageData, type: type })
              .then((res) => {
                resolve(res)
              })
              .catch((err) => {
                reject(err)
              })
          } else {
            reject()
          }
        })
      })
    },
    async reqAll() {
      if (this.pageData.type === 'OIL') {
        const oilres = await this.addSubmit('OIL')
        const uniqueId = web3.utils.padRight(web3.utils.toHex(oilres.result), 64)
        await this.handleAddProducer(this.oilContract, this.oilAddress, uniqueId)
        await this.$refs.ShareCom.submite(this.oilContract, this.oilAddress, uniqueId)
      } else if (this.pageData.type === 'GAS') {
        const gasres = await this.addSubmit('GAS')
        const uniqueId = web3.utils.padRight(web3.utils.toHex(gasres.result), 64)
        await this.handleAddProducer(this.gasContract, this.gasAddress, uniqueId)
        await this.$refs.ShareCom.submite(this.gasContract, this.gasAddress, uniqueId)
      } else {
        const oilres = await this.addSubmit('OIL')
        const oilUniqueId = web3.utils.padRight(web3.utils.toHex(oilres.result), 64)
        const gasres = await this.addSubmit('GAS')
        const gasUniqueId = web3.utils.padRight(web3.utils.toHex(gasres.result), 64)
        await this.handleAddProducer(this.oilContract, this.oilAddress, oilUniqueId)
        await this.handleAddProducer(this.gasContract, this.gasAddress, gasUniqueId)
        await this.$refs.ShareCom.submite(this.oilContract, this.oilAddress, oilUniqueId)
        await this.$refs.ShareCom.submite(this.gasContract, this.gasAddress, gasUniqueId)
      }
    },
    handleAddProducer(contract, address, uniqueId) {
      return new Promise((resolve, reject) => {
        const tx_builder = contract.methods['addProducer'](uniqueId, [
          this.pageData.nickname,
          this.$store.getters.metaMaskObj.account,
          Number(this.pageData.APIGravity) * 100,
          Number(this.pageData.sulphur) * 1000,
          ''
        ])
        const encoded_tx = tx_builder.encodeABI()

        const json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: address,
          value: 0,
          data: encoded_tx
        }
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve()
          })
          .catch((error) => {
            reject()
            this.$message.error('operation failed')
            console.error(error)
          })
      })
    },
    handleUpdateProducer() {
      return new Promise((resolve, reject) => {
        const uniqueId = web3.utils.padRight(web3.utils.toHex(this.pageData.wellID), 64)
        const contract = this.pageData.type === 'OIL' ? this.oilContract : this.gasContract
        const address = this.pageData.type === 'OIL' ? this.oilAddress : this.gasAddress
        const tx_builder = contract.methods['updateProdcuer'](uniqueId, [
          this.pageData.nickname,
          this.$store.getters.metaMaskObj.account,
          Number(this.pageData.APIGravity) * 100,
          Number(this.pageData.sulphur) * 1000
        ])
        const encoded_tx = tx_builder.encodeABI()

        const json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: address,
          value: 0,
          data: encoded_tx
        }
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve()
          })
          .catch((error) => {
            reject()
            this.$message.error('operation failed')
            console.error(error)
          })
      })
    },
    getId(row) {
      return web3.utils.padRight(web3.utils.toHex(row.wellID), 64)
    }
  }
}
</script>
<style scoped lang="scss">
.reject_box {
  background: #FAFAFA;
  padding: 0.2rem 0.24rem;
  margin-bottom: 0.24rem;

  .sub_title {
    justify-content: flex-start !important;
    align-items: center;
  }
}

.point-page {
  .sub_title {
    font-size: 0.18rem;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #000000;
    line-height: 0.28rem;
    margin-bottom: 0.16rem;
    display: flex;
    justify-content: space-between;
  }

  .sub_title.img {

    justify-content: flex-start;
  }

  .refusalReason {
    font-size: 0.14rem;
    line-height: 0.24rem;
    padding-left: 0.28rem;
  }

  .point-form {
    padding: 0 0.32rem;
  }
}
</style>
